'use client';

import ErrorPage from '@/components/ErrorPage';
import { INotFoundDictionary } from '@/dictionaries/utils/notFound/types';
import { useEffect } from 'react';

interface IError {
  error: Error & { digest?: string };
  reset: () => void;
}

const dict = {
  title: 'Unexpected Error',
  description: 'Please contact the customer service',
};

export default function GlobalError({ error, reset }: IError) {
  useEffect(() => {
    // Log the error to an error reporting service
    console.error(error);
  }, [error]);

  return (
    <html>
      <body>
        <ErrorPage
          errorType="error"
          dict={
            {
              error: dict,
            } as INotFoundDictionary
          }
          lang={'en'}
        />{' '}
        <button onClick={() => reset()}>Try again</button>
      </body>
    </html>
  );
}
